import { SET_COOKIE_POLICY_CONTENT } from "actions/types";

let initialState = {
  cookiePolicyContent: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_COOKIE_POLICY_CONTENT: {
      return {
        ...state,
        cookiePolicyContent: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
